import { extendTheme } from '@mui/material/styles';

export const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: { main: '#1F3C6E' },
        secondary: { main: '#00A876' },
        error: { main: '#D50000' },
        warning: { main: '#DC7D00' },
        success: { main: '#039112' },
      },
    },
    dark: {
      palette: {
        primary: { main: '#89CEE3' },
        secondary: { main: '#00A876' },
        error: { main: '#F2B3B3' },
        warning: { main: '#DC7D00' },
        success: { main: '#039112' },
      },
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});
